import React from 'react';
import Container from '../../../containers/integration/screens/showScreenContainer';

export default function () {
  return (
    <Container />
  );
}
